import styled from 'styled-components';

import { cCC38FF } from '#/colors';
import { DISCORD_URL } from '#/routes-external';
import { useWalletView } from '#/features/wallet/wallet-context';
import { useTranslation } from '#/features/localization/utils';

interface Props {
  readonly className?: string;
}

export default function JoinWaitlist(props: Props) {
  const walletView = useWalletView();
  const { t } = useTranslation();

  if (walletView.isSignedIn) return null;

  return (
    <ExternalLink className={props.className} href={DISCORD_URL}>
      {t('Join Discord')}
    </ExternalLink>
  );
}

const ExternalLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener',
})`
  display: grid;
  place-items: center;
  text-align: right;

  color: ${cCC38FF};
  font-size: 13px;
  font-weight: bold;
`;
